import React from 'react';
import bindAll from 'lodash.bindall';
import Draggable from 'react-draggable';
import event, { EVENTS } from '../../lib/event.js';
import Audio from "../../lib/audio.js";
import styles from './cartoon.css';
import defaultGif from './shutup.gif';
import goodGif from './good.gif';
import speak from './speak.gif';
import awkward from './awkward.gif';
import Mute from './jingyin.png';
// import head from './head.png';


// class speakFun {
//     static speak(content){
//         console.log(content)
//         // console.log(this.props)
//     }
// }

const App = ({ content }) => {
    const [placeholder, setPlaceholder] = React.useState('');

    if (content) {
        const
            index = React.useRef(0);

        React.useEffect(() => {
            function tick() {
                setPlaceholder(prev => prev + content[index.current]);
                index.current++;
            }
            if (index.current < content.length) {
                let addChar = setInterval(tick, 30);
                return () => clearInterval(addChar);
            }
        }, [placeholder]);

        return (
            <div>
                {placeholder}
            </div>
        )
    } else {
        return (
            <div></div>
        )
    }
}

class CartoonEditor extends React.PureComponent {
    constructor(props) {
        super(props);
        bindAll(this, [
            'onDrag',
            'handleStop'
        ]);
        this.state = {
            gifUrl: defaultGif,
            speakContent: null,
            speakStatus: false,
            speakTitle: null,
            playAudio: false,
            position: styles.default,
            showMute: false,
            currentIndex: 0,
            isStateSmall:false,
        }

        CartoonEditor.speak = this.speak.bind(this);
        CartoonEditor.good = this.good.bind(this);
        CartoonEditor.noSpeak = this.noSpeak.bind(this);
        CartoonEditor.defaultState = this.defaultState.bind(this);
        CartoonEditor.awkward = this.awkward.bind(this);
        CartoonEditor.onlySpeak = this.onlySpeak.bind(this);
        CartoonEditor.muteHide = this.muteHide.bind(this);
        CartoonEditor.setSmall = this.setSmall.bind(this);
    }

    // componentDidMount() {
    //     event.on('NO_TALK', this.noSpeak)
    //     event.on('SPEAKING', this.good)
    // }

    // componentWillReceiveProps(nextProps) {
    //     console.log(nextProps)
    // }

    //默认
    defaultState() {
        this.setState({
            gifUrl: defaultGif,
            speakContent: null,
            speakStatus: 0,
            speakTitle: null,
            playAudio: false,
            isStateSmall:false,
        })
    }

    //赞
    good(text) {
        this.setState({
            gifUrl: goodGif,
        }, () => {
            this.setState({
                speakContent: text,
                playAudio: true,
                speakStatus: true
            })
        })
    }

    //说话
    speak(text, title, type) {
        this.setState({
            gifUrl: type == 3 ? awkward : speak,
            speakContent: text,
            speakTitle: title,
            playAudio: true,
            speakStatus: type
        })
    }

    //不说话
    noSpeak(type) {
        const { gifUrl, speakStatus } = this.state
        // console.log(gifUrl,awkward)
        this.setState({
            gifUrl: gifUrl === goodGif ? goodGif : gifUrl === awkward ? awkward : defaultGif,
            playAudio: false,
            // speakContent: null,
            speakStatus: speakStatus === 2 ? 2 : 0,
            showMute: type === 2 ? true : false,
            // speakTitle:null
        })
    }

    //尴尬
    awkward() {
        this.setState({
            gifUrl: awkward
        })
    }

    //光动嘴
    onlySpeak() {
        this.setState({
            gifUrl: speak
        })
    }

    //任务变小
    setSmall(){
        this.setState({
            isStateSmall:true
        })
    }


    onDrag() {
        const div = document.getElementById('cartoonEditor');
        div.addEventListener("touchmove", function (event) {
            event.preventDefault();
        }, false);
    }

    handleStop() {
        const div = document.getElementsByClassName('react-draggable');
        const ele = div[0].style.transform;
        const obj = ele.match(/\((.+?)\)/g);
        const str = obj[0].replace(/\(|\)/g, '').split(',');
        const x = parseInt(str[0]);
        const y = parseInt(str[1]);
        const boundaryValueX = document.body.clientWidth / 2 + 40;
        const boundaryValueY = document.body.clientHeight / 2 - 40

        let position;
        if (x < -(boundaryValueX) && y > -(boundaryValueY)) {
            position = styles.closeLeft
        } else if (y < -(boundaryValueY) && x > -(boundaryValueX)) {
            position = styles.closeTop
        } else if (y < -(boundaryValueY) && x < -(boundaryValueX)) {
            position = styles.closeLeftTop
        } else {
            position = styles.default
        }
        this.setState({
            position: position,
            playAudio: false
        })
    }

    cancel() {
        this.setState({
            speakStatus: 0
        }, () => {
            event.emit(EVENTS.CANCEL_GUIDE);
        })
    }

    confirm() {
        this.setState({
            speakStatus: 0,
            currentIndex: 0
        }, () => {
            event.emit(EVENTS.NEXT_GUIDE);
        })
    }

    muteHide() {
        this.setState({
            showMute: false
        })
    }

    render() {
        const {
            gifUrl,
            speakStatus,
            speakContent,
            speakTitle,
            playAudio,
            position,
            showMute,
            isStateSmall,
        } = this.state
        // console.log(showMute)
        if (playAudio) {
            Audio.tts((speakTitle ? (speakTitle + '。') : "") + (speakContent || ""));
        }
        let isSmall = false
        if (location.pathname.indexOf('lesson') !== -1 || location.pathname.indexOf('project') !== -1) {
            isSmall = true
        }
        if(speakStatus === 2) {
            isSmall = false
        }
        if(gifUrl === goodGif){
            isSmall = false
        }

        return (
            <div>
                <Draggable
                    disabled={false}
                    bounds={{ left: -(document.body.clientWidth - 310), bottom: 0, top: -(document.body.clientHeight - 210), right: 150 }}
                    onDrag={() => this.onDrag()}
                    onStop={() => this.handleStop()}
                >
                    <div></div>
                    {/* <div className={`${styles.cartoonBox} ${isSmall && isStateSmall ? styles.cartoonSmall : styles.cartoonBig}`}>
                        <img className={isSmall && isStateSmall ? styles.smallCartoon : styles.bigCartoon} src={gifUrl} onContextMenu={() => { return false; }} />
                        {speakStatus === 1 ? (
                            <div className={`${styles.contentBox} ${position}`}>{speakContent}</div>
                        ) : (speakStatus === 2 ? (
                            <div className={`${styles.contentBox} ${position}  ${position}`}>
                                <h3>{speakTitle ? speakTitle : '温馨提示'}{showMute ? (<img src={Mute} onClick={() => this.muteHide()} />) : (null)}</h3>
                                <App content={speakContent} />
                                <div className={styles.btnBox}>
                                    {/* <span onClick={() => this.cancel()}>取消</span>
                                    <span onClick={() => this.confirm()}>下一步</span>
                                </div>
                            </div>
                        ) : (null))}
                    </div> */}
                </Draggable>

                {/* {speakStatus === 2 ? (
                    <div className={styles.mask}></div>
                ) : (null)} */}
            </div>
        );
    }
}

export default CartoonEditor;
